import { createFileRoute, redirect } from "@tanstack/react-router";

import { getSession } from "@ando/core/auth";

import { surfaceAccess } from "@/features/console/access";
import { getPreferredSurface } from "@/features/console/lib/surface";
import { resolveWorkspaceLandingRoute } from "@/features/workspace-router";

/**
 * ``_authed/`` default — DUAL-SURFACE landing (Jul 2026).
 *
 * Surface pick, in order (entitlements from ``surfaceAccess``):
 *   1. console-only (``platform-dev``) → ``/console`` (the console IS
 *      their app; product routes are guarded off in ``_authed/route.tsx``)
 *   2. both surfaces → restore the LAST-USED surface persisted under the
 *      ``ando.surface`` localStorage key (default: product)
 *   3. product-only → unchanged: resume the last workspace tab
 *      (June 10, 2026; extracted helper Jul 22, 2026 shared with
 *      ``_authed/workspace/index.tsx``).
 *
 * The workspace fallback restores the last tab the user was on — SOTA
 * admin-UX (Notion, Linear, Cursor) restores the last surface; we do the
 * same one level up for the product/console split.
 */
export const Route = createFileRoute("/_authed/")({
  beforeLoad: () => {
    const access = surfaceAccess(getSession());
    if (access.console && (!access.product || getPreferredSurface() === "console")) {
      throw redirect({ to: "/console" });
    }
    throw redirect({ to: resolveWorkspaceLandingRoute() });
  },
});
